// HomeLivestreamJsonLd.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import serialize from 'serialize-javascript';
import { withTranslation } from 'react-i18next';

export const HomeLivestreamJsonLd = ({ t }) => {
  return (
    <Helmet>
      <script type="application/ld+json" helmetKey="jsonld">
        {serialize(
          {
            '@context': 'https://schema.org',
            '@graph': [
              {
                '@type': 'WebPage',
                '@id': 'https://swag.live/livestream#webpage',
                url: 'https://swag.live/livestream',
                name: t('seo_livestream_title'),
                breadcrumb: {
                  '@id': 'https://swag.live/livestream#breadcrumb',
                },
              },
              {
                '@type': 'BreadcrumbList',
                '@id': 'https://swag.live/livestream#breadcrumb',
                itemListElement: [
                  {
                    '@type': 'ListItem',
                    position: 1,
                    name: t('seo-home-title'),
                    item: 'https://swag.live',
                  },
                  {
                    '@type': 'ListItem',
                    position: 2,
                    name: t('seo_livestream_title'),
                    item: 'https://swag.live/livestream',
                  },
                ],
              },
            ],
          },
          { isJSON: true }
        )}
      </script>
    </Helmet>
  );
};

HomeLivestreamJsonLd.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(HomeLivestreamJsonLd);
